import { render } from "./ImageArea.vue?vue&type=template&id=09aa451f"
import script from "./ImageArea.vue?vue&type=script&lang=js"
export * from "./ImageArea.vue?vue&type=script&lang=js"

import "./ImageArea.vue?vue&type=style&index=0&id=09aa451f&lang=css"
script.render = render

export default script